<app-loading *ngIf="!show_landing_page; else showLandingPage"></app-loading>
<ng-template #showLandingPage>
    <app-navbar class="home"></app-navbar>
    <div class="redemption-landing-wrapper">
        <div class="container">

            <section class="redemption-landing-banner">
                <div class="row">
                    <div class="col-md-6 pt-5">
                        <h1 class="display-5">You have received a voucher?</h1>
                        <p class="display-6">Please login to redeem.</p>
                        <a class="btn btn-secondary" (click)="getStarted()">
                            Login
                            <i class="bi bi-arrow-right ms-2"></i>
                        </a>
                        <p class="mt-3">
                            Don’t have an account yet? Click here to <a routerLink="/auth/signup">sign up</a>!
                        </p>
                    </div>
                    <div class="col-md-6 pop-up-form-demo text-end py-5">
                        <img loading="lazy" src="assets/landing/3.png" width="100%" />
                    </div>
                </div>
            </section>
        </div>
    </div>

    <div class="container">
        <section class="landing-contents">
            <div class="row my-5">
                <div class="col-md-12 text-center pt-5">
                    <h1>You can generate QR Codes with your brand logo and get instant access to analytics thanks to us.
                    </h1>
                    <p>We offer a free and simple way to generate QR Codes which you can use in your marketing
                        campaigns, product
                        packaging, on websites, on business cards and so on.</p>
                </div>
            </div>
            <app-core-faqs-landing-page [category]="faq_category"></app-core-faqs-landing-page>
            <div class="row mb-5">
                <div class="col-md-12 text-center">
                    <h1>Have a concern that is not being addressed?</h1>
                    <a class="btn btn-secondary-light" routerLink="/contact-us">
                        <i class="bi bi-envelope me-2"></i>
                        Contact us</a>
                </div>
            </div>
            <br>
            <br>
        </section>
    </div>

    <app-footer></app-footer>
</ng-template>